import React from "react";
import Heading from "../components/HomeScreen/Home";

const HomeScreen = () => {
  return (
    <div>
      <Heading />
      {/* <Banner /> */}
      {/* <Banner2 /> */}
      {/* <List />
      <Subscription /> */}
    </div>
  );
};

export default HomeScreen;
